<!--  no need for this for now -->
<template>
  <div id="contract-manager" class="clearfix gibson px2 mb4">
    <div class="col-12">
          <div class="clearfix">
            <div class="col-12 mt2 px0 flex justify-between items-center">
                <p class="h1 regular line-height-2 my3">Godkendte projekter</p>
            </div>
            <div v-if="loading">
              <div class="col-12">
                <div class="loader"></div>
              </div>
            </div>
            <div v-else>
            </div>
          </div>
      </div>
  </div>
</template>
<script>
export default {
  name: 'contract-manager',
  components: {
  },
  created () {
    this.displayCurrentProject()
  },
  data () {
    return {
      haaId: localStorage.getItem('haaid'),
      salesPerson: localStorage.getItem('id_token_portalbitrix'),
      loading: true
    }
  },
  methods: {
  }
}
</script>
<style>
  #contract-manager .el-input__inner {
    -webkit-appearance: auto;
  }
  #contract-manager .loader,
  .loader:before,
  .loader:after {
    border-radius: 50%;
  }
  #contract-manager .loader {
    color: #143130;
    font-size: 11px;
    text-indent: -99999em;
    margin: 55px auto;
    position: relative;
    width: 10em;
    height: 10em;
    box-shadow: inset 0 0 0 1em;
    -webkit-transform: translateZ(0);
    -ms-transform: translateZ(0);
    transform: translateZ(0);
  }
  #contract-manager .loader:before,
  .loader:after {
    position: absolute;
    content: '';
  }
  #contract-manager .loader:before {
    width: 5.2em;
    height: 10.2em;
    background: white;
    border-radius: 10.2em 0 0 10.2em;
    top: -0.1em;
    left: -0.1em;
    -webkit-transform-origin: 5.2em 5.1em;
    transform-origin: 5.2em 5.1em;
    -webkit-animation: load2 2s infinite ease 1.5s;
    animation: load2 2s infinite ease 1.5s;
  }
  #contract-manager .loader:after {
    width: 5.2em;
    height: 10.2em;
    background: white;
    border-radius: 0 10.2em 10.2em 0;
    top: -0.1em;
    left: 5.1em;
    -webkit-transform-origin: 0px 5.1em;
    transform-origin: 0px 5.1em;
    -webkit-animation: load2 2s infinite ease;
    animation: load2 2s infinite ease;
  }
  @-webkit-keyframes load2 {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
  @keyframes load2 {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
</style>


// WEBPACK FOOTER //
// contract-manager.vue?4c4eae8a